export enum ReservationDateFilterField {
  CREATED_AT = 'createdAt',
  START_DATE = 'startDate',
  START_TIME = 'startTime',
}
